import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { constants } from '../../common/constants/constants';
import { GAEvent } from '../../common/google_analytics/google_analytics';
import Button from '../../common/Button';
import arrowInCircle from '../../images/newDesign/arrow_in_white_circle.svg';
import PaymentFlowContainer from './PaymentFlowContainer';
import { StyledLearnMore } from './LearnMore.styled';

const LearnMore = ({ match }) => {
    const { t } = useTranslation();

    const ltr = useSelector(state => state.common.ltrEnabled);

    const onBackBtnClick = () => window.history.back();

    const onCallBtnClick = () => {
        window.open(`https://api.whatsapp.com/send?phone=97235395479&source=&data=`);
        // todo remove constants.GoogleAnalytics.Events.learnMoreWA event
        GAEvent(constants.GoogleAnalytics.Events.learnMoreWA, 'learnMoreWA', 1, 'learnMoreWA');
        GAEvent(constants.GoogleAnalytics.Events.clicks, 'learnMoreWA', 1, 'learnMoreWA');
    };

    function onCloseClick() {
        window.history.back()
    }

    return (
        <PaymentFlowContainer title={t('payments.spread_payment')}>
            <span className='close-btn' onClick={onCloseClick}>&#215;</span>
            <StyledLearnMore ltr={ltr}>
                <div>
                    <div className='qa-title'>{t('payments.when_deploy_payments')}</div>
                    <div>{t('payments.divide_payments_info')}</div>
                </div>

                <div className='middle-block'>
                    <div className='qa-title'>{t('payments.how_to_divide')}</div>
                    <div>{t('payments.division_info')}</div>
                </div>

                <div className='contact-info-block'>
                    <div className='qa-title'>{t('payments.contact_info')}</div>
                    <div className='contacts'>
                        <span>{t('payments.moked_bllink')}</span>
                        <a className='clickable-info' href="tel:035395479">03-5395479</a>
                    </div>
                    <div className='contacts'>
                        <span>{t('payments.mail')}</span>
                        <a className='clickable-info' href="mailto:support@bllink.co">support@bllink.co</a>
                    </div>
                </div>

                <div className='back-to-payments' onClick={onBackBtnClick}>{t('payments.back_to_payments')}</div>

                <Button onClick={onCallBtnClick}>
                    {t('payments.contact_representative')}
                    <img className='arrow' src={arrowInCircle} />
                </Button>
            </StyledLearnMore>
        </PaymentFlowContainer>
    )
}

export default LearnMore;
